module.exports = __webpack_public_path__ + "static/media/nds_logo.7459ce05.png";